const IconRevenue = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 48 48">
    {/* Single banknote */}
    <rect
      x="6"
      y="14"
      width="36"
      height="20"
      rx="2"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.5"
    />
    {/* Euro symbol as text */}
    <text
      x="24"
      y="29"
      fontSize="20"
      fontWeight="bold"
      textAnchor="middle"
      fill="currentColor"
    >
      €
    </text>
  </svg>
);

export default IconRevenue;
